module.exports = __webpack_public_path__ + "static/media/ils_gold_sell_failed.bd461def.svg";